import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoriesSection.css';

const categories = [
  { label: 'Sundaes', img: '/assets/categories/c1.png' },
  { label: 'Cones', img: '/assets/categories/c2.png' },
  { label: 'Milkshakes', img: '/assets/categories/c3.png' },
  { label: 'Fresh juice', img: '/assets/categories/c4.png' },
  { label: 'Icecream Cakes', img: '/assets/categories/c5.png' },
  { label: 'Falooda', img: '/assets/categories/c6.png' },
  { label: 'Kulfi', img: '/assets/categories/c7.png' },
  { label: 'Bombay Gola', img: '/assets/categories/c8.png' },
];

// Helper to split into chunks of 4
const chunkArray = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

const CategoriesSection = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryLabel) => {
    // Map category labels to their corresponding navigation paths
    const categoryNavigation = {
      'Sundaes': '/novelties?type=sundaes',
      'Cones': '/ice-cream',
      'Milkshakes': '/novelties?type=milkshakes',
      'Fresh juice': '/novelties?type=fresh-juices',
      'Icecream Cakes': '/novelties?type=ice-cream-cakes',
      'Falooda': '/novelties?type=falooda',
      'Kulfi': '/novelties?type=kulfi',
      'Bombay Gola': '/novelties?type=bombay-gola',
    };

    const path = categoryNavigation[categoryLabel];
    if (path) {
      navigate(path);
    } else {
      // Fallback to novelties page
      navigate('/novelties');
    }
  };

  return (
    <section className="categories-section">
      <div className="categories-heading">
        <span>
          Explore our <span className="highlight">best</span>
        </span>
        <br />
        <span>Categories</span>
      </div>
      <div className="categories-slider-grid">
        <div className="categories-grid">
          {categories.map((cat, i) => (
            <div className="category-card" key={cat.label}>
              <div className="category-arch-bg">
                <img
                  src={process.env.PUBLIC_URL + cat.img}
                  alt={cat.label.replace(/\n/g, ' ')}
                  className="category-img"
                />
              </div>
              <button className="category-btn" onClick={() => handleCategoryClick(cat.label)}>
                <span className="category-btn-text">
                  {cat.label.split('\n').map((line, idx, arr) => (
                    <span key={idx}>
                      {line}
                      {idx !== arr.length - 1 && <br />}
                    </span>
                  ))}
                </span>
                <span className="category-btn-arrow">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="none" />
                    <path
                      d="M8 12h8m0 0-3-3m3 3-3 3"
                      stroke="#ff6a00"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
